import React, { Component } from 'react';
import Lightbox from 'react-image-lightbox';

const getTitle = (curr, len) => {
  return (
    <span> {`${curr} of ${len}`} </span>
  )
};

class PhotoLightbox extends Component {
  state = {
    currentImage: this.props.currentImage || 0,
  };

  componentWillUnmount() {
		if(this.props.lightboxIsOpen) {
			window.location.reload();
		}
  };

  componentWillReceiveProps(nextProps, lastProps) {
    if(nextProps.currentImage !== this.state.currentImage) {
      this.setState({currentImage: nextProps.currentImage})
    }
  };

  closeLightbox = () => {
    this.props.onClose();
    this.setState({
			currentImage: 0,
    });
  };

  gotoPrevious = () => {
    this.setState({
      currentImage: (this.state.currentImage + this.props.images.length - 1) 
        % this.props.images.length,
    });
  };

  gotoNext = () => {
    this.setState({
			currentImage: (this.state.currentImage + 1) % this.props.images.length,
		});
  };

  render() {
    const {
      images,
      allowZoom,
      lightboxIsOpen,
    } = this.props;

    const {
      currentImage,
    } = this.state;

    return (
      lightboxIsOpen ? 
        <Lightbox
          mainSrc={images[currentImage].src}
          nextSrc={images[(currentImage + 1) % images.length].src}
          prevSrc={images[(currentImage + images.length - 1) % images.length].src}
          onCloseRequest={this.closeLightbox}
          onMovePrevRequest={this.gotoPrevious}
          onMoveNextRequest={this.gotoNext}
          enableZoom={allowZoom}
          imageTitle={getTitle(currentImage + 1, images.length)}
          clickOutsideToClose={true}
        /> :
        null    
    )
  }
}

export default PhotoLightbox;



// WEBPACK FOOTER //
// ./src/components/pages/Photos/PhotoLightbox.jsx